import React, { useEffect } from "react";
import MaskedInput from "react-text-mask";
import { useField } from "formik";
import * as yup from "yup";

import OutlinedInput from "@mui/material/OutlinedInput";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";

import { omit } from "lodash";
import { US_PHONE_MASK } from "utils/phone";
import { Control } from "pages/eligibility/type";
import { keyFromIdentity } from "../helpers";
import { QuestionProps } from "../question";

export const validator = (
  question: QuestionProps,
  _questionsMap: Record<string, QuestionProps>,
  parent?: string,
  index?: number,
): Record<string, yup.AnySchema> => {
  const key = keyFromIdentity(question.identity, parent, index);
  const validate = yup.string().validPhoneNumber("Must be a valid 10 digit phone number");
  return {
    [key]: question.required ? validate : validate.nullable(),
  };
};

const TextMaskCustom: React.FC = (props) => {
  const other = omit(props, ["inputRef"]);

  return (
    <MaskedInput
      {...other}
      mask={US_PHONE_MASK}
      placeholderChar={"\u2000"}
    />
  );
};

const FormQuestionFaxNumber: Control<"FormQuestionFaxNumber"> & { validator: any } = (props : any): React.ReactElement => {
  const { name, title, required } = props;
  const [field, meta, helpers] = useField(name);
  // Validate on transition:
  useEffect(() => () => {
    helpers.setTouched(true);
  }, []);

  return (
    <FormControl
      fullWidth
      variant="outlined"
      margin="dense"
    >
      <InputLabel shrink error={meta.touched && !!meta.error} htmlFor={`${name}-outlined`}>
        {`${title}${required ? "*" : ""}`}
      </InputLabel>

      <OutlinedInput
        {...field}
        label={`${title}${required ? "*" : ""}`}
        margin="dense"
        notched
        id={`${name}-outlined`}
        error={meta.touched && !!meta.error}
        inputComponent={TextMaskCustom as any}
        placeholder="(555) 123-7698"
      />

      {meta.touched && meta.error && (
        <FormHelperText className="color-hc-error">
          {meta.error}
        </FormHelperText>
      )}
    </FormControl>
  );
};

FormQuestionFaxNumber.validator = validator;
export default FormQuestionFaxNumber;


